import { Languages } from "src/common/descriptions/types";
import { CreateContractPaymentDescriptions } from "./types";

const DescriptionsEnUs: CreateContractPaymentDescriptions = {
    SECONDARY_TITLE: "Create Payable Payment",
    TITLE: "Create Customer Payment",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save payment?',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Payment input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Payment Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Payment Updated",
    },
    FORM: {
        CASH: {
            LABEL: "Cash",
            PLACEHOLDER: "0.00",
        },
        TRANSACTION: {
            LABEL: "Transaction",
            PLACEHOLDER: "0.00",
        },
        DISSCOUNT: {
            LABEL: "Disscount",
            PLACEHOLDER: "0.00",
        },
        COMMENT: {
            LABEL: "Comment",
            PLACEHOLDER: "Input comment",
        },
        PAYMENT_TOTAL: {
            LABEL: "Payment Total",
            PLACEHOLDER: "0.00",
        },
        PREVIOUS_BALANCE: {
            LABEL: "Previous Balance",
            PLACEHOLDER: "0.00",
        },
        NEW_BALANCE: {
            LABEL: "New Balance",
            PLACEHOLDER: "0.00",
        },
        ORIGIN: {
            LABEL: "Origin",
            PLACEHOLDER: "Select",
        },
    },
    MAIN_ACTION_TITLE: "Creating Customer",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    DESCRIPTIONS: {
        CUSTOMER: "Customer",
        DESCRIPTION: "Description",
        AMOUNT: "Debit Amount",
        CREATED_AT: "Created at",
        AMOUNT_PAYED: "Amount Payed",
        OUTSTANDING: "Outstanding",
    },
    PAYMENT_GREATER_THAN_TOTAL: "Payment must be lower or equal as the total to pay",
    CASHBOX: "Cashbox",
    BANK: "Bank",
    BALANCE: "Balance",
    AMOUNT_MUST_BE_LET_BALANCE: "Payment amount must be lower or equal than balance",
}

const DescriptionsEsUs: CreateContractPaymentDescriptions = {
    SECONDARY_TITLE: "Crear Pago a Proveedores",
    TITLE: "Crear Pago de Clientes",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Pago con los datos ingresados?',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Pago?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Pago creado",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Pago Actualizado",
    },
    ERRORS: {
        REQUIRED_FIELD: (fieldName: string) => `${fieldName} es requerido.`,
        SAVE_ACTION: "",
        UNKNOWN: "Ha ocurrido un error al procesar la operación, por favor contacta a soporte."
    },
    FORM: {
        CASH: {
            LABEL: "Efectivo",
            PLACEHOLDER: "0.00",
        },
        TRANSACTION: {
            LABEL: "Transacción",
            PLACEHOLDER: "0.00",
        },
        DISSCOUNT: {
            LABEL: "Descuento",
            PLACEHOLDER: "0.00",
        },
        COMMENT: {
            LABEL: "Observaciones",
            PLACEHOLDER: "Ingrese observaciones",
        },
        PAYMENT_TOTAL: {
            LABEL: "Total de Pago",
            PLACEHOLDER: "0.00",
        },
        PREVIOUS_BALANCE: {
            LABEL: "Saldo Anterior",
            PLACEHOLDER: "0.00",
        },
        NEW_BALANCE: {
            LABEL: "Nuevo Saldo",
            PLACEHOLDER: "0.00",
        },
        ORIGIN: {
            LABEL: "Orígen",
            PLACEHOLDER: "Selecciona",
        },
    },
    MAIN_ACTION_TITLE: "Creando Pago",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    DESCRIPTIONS: {
        CUSTOMER: "Cliente",
        DESCRIPTION: "Descripción",
        AMOUNT: "Total Débito",
        CREATED_AT: "Creado",
        AMOUNT_PAYED: "Pagado",
        OUTSTANDING: "Saldo Actual",
    },
    PAYMENT_GREATER_THAN_TOTAL: "El Pago debe ser menor o igual al total a pagar",
    CASHBOX: "Caja",
    BANK: "Banco",
    BALANCE: "Saldo",
    AMOUNT_MUST_BE_LET_BALANCE: "El pago debe ser menor o igual al saldo en caja",
}

export const createContractPaymentDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}